import fromPairs from "lodash/fromPairs"
import formatStoredField from "shared/lib/format_stored_field"

const initialState = {
  byService: {},
  fieldDefaults: {},
}

export default function actions(state = initialState, event) {
  switch (event.type) {
    default: {
      return state
    }

    // Since the default field values are scoped by trigger, we need to clear
    // them when the user selects a different trigger.
    case "SELECT_TRIGGER": {
      return {
        ...state,
        fieldDefaults: {},
      }
    }

    case "ACTIONS_LOADED": {
      const defaults = {}
      const actions = fromPairs(
        event.actions.map(action => {
          if (action.defaults_for_trigger) {
            defaults[action.id] = JSON.parse(action.defaults_for_trigger)
          }

          return [
            action.module_name,
            {
              ...action,
              channel_module_name: event.serviceModuleName,
              fields: action.action_fields.map(actionField => ({
                ...actionField,
                default_value: defaults[actionField.name],
                stored_field: formatStoredField(
                  "action",
                  action.full_module_name,
                  actionField
                ),
              })),
            },
          ]
        })
      )

      return {
        ...state,
        byService: {
          ...state.byService,
          [event.serviceModuleName]: actions,
        },
        fieldDefaults: {
          ...state.fieldDefaults,
          [event.serviceModuleName]: defaults,
        },
      }
    }
  }
}

export const actionQueryFields = `
  module_name
  full_module_name
  name
  description
  id
  normalized_module_name
  incompatible_triggers

  channel {
    id
    module_name
    normalized_module_name
  }

  action_fields {
    id
    name
    label
    field_ui_type
    field_type
    required
    normalized_field_type
    shareable
    hideable
    can_have_default
    helper_text
    normalized_module_name
  }
`

export function actionFieldDefaultsQuery(triggerId) {
  return `defaults_for_trigger(trigger_id: ${JSON.stringify(
    triggerId.toString()
  )})`
}
